import { z } from 'zod'
import { createIncomeSchema } from './create-income.schema'

export const updateIncomeSchema = createIncomeSchema.partial()

export type UpdateIncomeDto = z.infer<typeof updateIncomeSchema>
